(() => {
  'use strict';

  const setupGallery = (gallery) => {
    if (!gallery || gallery.dataset.mbGalleryReady === 'true') return;
    const items = [...gallery.querySelectorAll('.product__media-list > [data-media-id]')];
    if (!items.length) return;

    const thumbnails = [...gallery.querySelectorAll('.thumbnail-list__item[data-target]')];
    const viewerControls = gallery.querySelector('#GalleryViewer-' + gallery.id.replace('MediaGallery-', '') + ' .slider-buttons');
    const current = viewerControls?.querySelector('.slider-counter--current');
    const total = viewerControls?.querySelector('.slider-counter--total');
    const productRoot = gallery.closest('.product');
    const info = productRoot?.querySelector('.product__info-container');
    const header = document.querySelector('.section-matchboox-header, .section-header');
    let index = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
    let timer;

    const alignActiveMedia = () => {
      const item = items[index];
      const container = item?.querySelector('.product-media-container');
      const media = container?.querySelector('.product__media.media');
      if (!media) return;

      if (window.innerWidth < 990 || !info) {
        media.style.removeProperty('--mb-media-shift');
        return;
      }

      /* Eerst zonder verschuiving meten. Zo blijft de berekening stabiel na
         wisselen van afbeelding, roteren of wijzigen van de venstermaat. */
      media.style.setProperty('--mb-media-shift', '0px');
      const mediaRect = media.getBoundingClientRect();
      const infoRect = info.getBoundingClientRect();
      let shift = infoRect.top - mediaRect.top;

      if (container.classList.contains('mb-media-kind--preview') || index >= 2) {
        /* Inkijkbeelden staan meestal vanaf afbeelding 3. Centreer daarom
           zowel expliciet herkende inkijkbeelden als afbeelding 3 en verder
           exact tegenover het volledige informatieblok rechts. */
        shift = (infoRect.top + infoRect.height / 2) - (mediaRect.top + mediaRect.height / 2);
      } else if (container.classList.contains('mb-media-kind--cover')) {
        /* De cover begint iets boven het rechter blok, zoals afgesproken. */
        shift -= 45;
      } else if (container.classList.contains('mb-media-kind--booklet')) {
        /* Het kleine boekje bevat meer wit in het bronbeeld en staat daarom
           iets hoger dan de cover. */
        shift -= 75;
      }

      /* Afbeelding 1 mag nooit onder de vaste header schuiven. De onderrand van
         de werkelijk gerenderde header is leidend, ook wanneer die later hoger wordt. */
      if (index === 0 && header) {
        /* Rekenen in paginacoördinaten: de header is sticky, dus bij een
           gescrolde pagina (bijv. na terugklikken) mag de huidige
           schermpositie van de header de verschuiving niet beïnvloeden. */
        const headerBottomDoc = header.getBoundingClientRect().height + 24;
        const mediaTopDoc = mediaRect.top + window.scrollY;
        shift = Math.max(shift, headerBottomDoc - mediaTopDoc);
      }

      media.style.setProperty('--mb-media-shift', `${Math.round(shift)}px`);
    };

    const scheduleAlignment = () => window.requestAnimationFrame(alignActiveMedia);

    const show = (nextIndex, focus = false) => {
      index = (nextIndex + items.length) % items.length;
      items.forEach((item, itemIndex) => {
        const active = itemIndex === index;
        item.classList.toggle('is-active', active);
        item.hidden = !active;
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      thumbnails.forEach((thumbnail) => {
        const active = thumbnail.dataset.target === items[index].dataset.mediaId;
        thumbnail.querySelector('button')?.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (current) current.textContent = String(index + 1);
      if (total) total.textContent = String(items.length);
      if (focus) items[index].querySelector('button, a, img')?.focus({ preventScroll: true });
      scheduleAlignment();
    };

    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (items.length > 1) {
        timer = window.setInterval(() => show(index + 1), 4000);
      }
    };

    viewerControls?.querySelector('.slider-button--prev')?.addEventListener('click', (event) => {
      event.preventDefault();
      show(index - 1);
      start();
    }, true);
    viewerControls?.querySelector('.slider-button--next')?.addEventListener('click', (event) => {
      event.preventDefault();
      show(index + 1);
      start();
    }, true);
    thumbnails.forEach((thumbnail) => {
      thumbnail.querySelector('button')?.addEventListener('click', () => {
        const nextIndex = items.findIndex((item) => item.dataset.mediaId === thumbnail.dataset.target);
        if (nextIndex >= 0) show(nextIndex);
        start();
      });
    });

    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    window.addEventListener('resize', scheduleAlignment, { passive: true });
    window.addEventListener('pageshow', scheduleAlignment);
    window.addEventListener('load', scheduleAlignment, { once: true });
    items.forEach((item) => item.querySelector('img')?.addEventListener('load', scheduleAlignment));
    if ('ResizeObserver' in window && info) new ResizeObserver(scheduleAlignment).observe(info);
    if ('ResizeObserver' in window && header) new ResizeObserver(scheduleAlignment).observe(header);

    gallery.classList.add('mb-gallery-ready');
    gallery.dataset.mbGalleryReady = 'true';
    show(index);
    start();
  };

  const setupAll = (root = document) => {
    if (root.matches?.('media-gallery')) setupGallery(root);
    root.querySelectorAll?.('media-gallery').forEach(setupGallery);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupAll(), { once: true });
  else setupAll();
  window.addEventListener('load', () => setupAll(), { once: true });
  window.setTimeout(() => setupAll(), 600);
  document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
})();
